// src/index.js
import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import keycloak from './keycloak';

const Index = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authInitialized, setAuthInitialized] = useState(false);
  const hasInit = useRef(false);          // <-- bandera estable

  useEffect(() => {
    if (hasInit.current) return;          // <-- evita la 2.ª llamada
    hasInit.current = true;

    const initOptions = {
      checkLoginIframe: false,
      pkceMethod: 'S256',
      enableLogging: true,
      silentCheckSsoFallback: false,
      flow: 'standard',
    };

    keycloak
      .init(initOptions)
      .then((authenticated) => {
        setIsAuthenticated(authenticated);
        setAuthInitialized(true);

        if (authenticated) {
          console.log('Usuario autenticado:', keycloak.tokenParsed?.preferred_username);

          keycloak.onTokenExpired = () =>
            keycloak.updateToken(30).catch(() =>
              console.error('No se pudo actualizar el token')
            );
        } else {
          keycloak.login();
        }
      })
      .catch((err) => {
        console.error('Error al inicializar Keycloak:', err);
        setAuthInitialized(true);
      });
  }, []);

  if (!authInitialized) {
    return (
      <div className="loading-container">
        <div className="loading-spinner" />
        <p>Inicializando autenticación…</p>
      </div>
    );
  }

  return <App keycloak={keycloak} isAuthenticated={isAuthenticated} />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Index />
  </React.StrictMode>
);
